module.exports = __webpack_public_path__ + "img/img1.ca5c3a35.svg";